import { cart, userErrors } from '../objects/cart'
// https://shopify.dev/docs/api/storefront/2024-04/mutations/cartLinesAdd
export const cartLinesAdd = `
mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!, $countryCode: CountryCode!) @inContext(country: $countryCode) {
  cartLinesAdd(cartId: $cartId, lines: $lines) {
    cart ${cart}
    userErrors ${userErrors}
  }
}`
